module.exports = __webpack_public_path__ + "static/media/incident_category-fire.5717cdc3.svg";